import { render, staticRenderFns } from "./Shift.vue?vue&type=template&id=12225f69&scoped=true"
import script from "./Shift.vue?vue&type=script&lang=js"
export * from "./Shift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12225f69",
  null
  
)

export default component.exports